var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('treeselect',{attrs:{"options":_vm.options,"value":_vm.value,"searchable":false,"show-count":true,"default-expand-level":1},scopedSlots:_vm._u([{key:"option-label",fn:function(ref){
    var node = ref.node;
    var shouldShowCount = ref.shouldShowCount;
    var count = ref.count;
    var labelClassName = ref.labelClassName;
    var countClassName = ref.countClassName;
return _c('label',{class:labelClassName},[_vm._v(" "+_vm._s(node.isBranch ? "Branch" : "Leaf")+": "+_vm._s(node.label)+" "),(shouldShowCount)?_c('span',{class:countClassName},[_vm._v("("+_vm._s(count)+")")]):_vm._e()])}}])})}
var staticRenderFns = []

export { render, staticRenderFns }